import ProductListActions from "@eisinc/Overrides/Widgets/ProductList/ProductListActions";
import ProductListProductImage from "@eisinc/Overrides/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation from "@eisinc/Overrides/Widgets/ProductList/ProductListProductInformation";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductCardStyles {
    container?: InjectableCss;
    imageWrapper?: InjectableCss;
    infoWrapper?: InjectableCss;
    actionsWrapper?: InjectableCss;
    searchScoreDataGridItem?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
}

export const productCardStyles: ProductListProductCardStyles = {
    container: {
        css: css`
            display: flex;
            align-items: stretch;
            width: 100%;
            @media only screen and (max-width: 1270px) {
                flex-wrap: wrap;
            }
        `,
    },
    imageWrapper: {
        css: css`
            width: 175px;
            height: 175px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            max-width: 100%;

            img {
                max-width: 175px;
                max-height: 175px;
                overflow: hidden;
            }
        `,
    },
    infoWrapper: {
        css: css`
            width: calc(100% - 505px);
            padding-left: 20px;
            padding-right: 20px;

            @media only screen and (max-width: 1270px) {
                width: calc(100% - 175px);
            }
        `,
    },
    actionsWrapper: {
        css: css`
            width: 330px;
            padding-left: 19px;
            border-left: 1px solid ${getColor("common.ui2")};
            padding-top: 10px;

            @media only screen and (max-width: 1270px) {
                width: 100%;
                padding-left: 195px;
                border-left: 0;
            }
        `,
    },
    sponsoredText: {
        css: css`
            margin-bottom: 5px;
            font-size: 0.9em;
            opacity: 0.5;
        `,
    },
};

const styles = productCardStyles;

const ProductListProductCard: FC<Props> = props => {
    return (
        <StyledWrapper {...styles.container} data-test-selector={`productListProductCard${props.product.id}`}>
            <StyledWrapper {...styles.imageWrapper}>
                {props.product.isSponsored && (
                    <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
                )}
                <ProductListProductImage
                    showImage={props.showImage}
                    showImageBadge={props.showImageBadges}
                    showTextBadge={props.showTextBadges}
                />
            </StyledWrapper>
            <StyledWrapper {...styles.infoWrapper}>
                <ProductListProductInformation
                    showBrand={props.showBrand}
                    showTitle={props.showTitle}
                    showPartNumbers={props.showPartNumbers}
                    showAvailability={props.showAvailability}
                    showAttributes={false}
                    showImageBadges={props.showImageBadges}
                    maxImageBadges={props.maximumNumberOfImageBadges}
                    showTextBadges={props.showTextBadges}
                    maxTextBadges={props.maximumNumberOfTextBadges}
                />
            </StyledWrapper>
            <StyledWrapper {...styles.actionsWrapper}>
                <ProductListActions
                    showPrice={props.showPrice}
                    showAddToList={props.showAddToList}
                    showCompare={props.showCompare}
                />
            </StyledWrapper>
            {/* <StyledWrapper {...styles.searchScoreDataGridItem}>
                <ProductSearchScoreData />
            </StyledWrapper> */}
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductCard);
